import { render, staticRenderFns } from "./ConsultaArmaLocDialogComponent.vue?vue&type=template&id=04ddefdb"
import script from "./ConsultaArmaLocDialogComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaArmaLocDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports